export default "__VITE_ASSET__YtzQ6M4p__"